import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-integration-step',
  templateUrl: './integration-step.component.html',
  styles: [
  ]
})
export class IntegrationStepComponent implements OnInit {
  @Input() content: any;

  constructor(  public dialogRef: NgbActiveModal) { }

  ngOnInit(): void {
  }

  confirm() {
    this.dialogRef.close({
      success: true,
    });
  }

  close() {
    this.dialogRef.close({ success: false });
  }
}
